import styles from "./OnboardingStyles.module.css"
import { useState } from 'react';
import PrimaryButton from "../Button/PrimaryButton/PrimaryButton";
import { StepFormProps } from "../../types/onboarding.types";
import SecondaryButton from "../Button/SecondaryButton/SecondaryButton";
import OnboardingPopup from "./OnboardingPopup";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useTranslation } from "react-i18next";
/**
* Onboarding step.
*
* @param props StepFormProps
* @param {(step: number) => void} props.setStep - Step change handler
* @param {number} props.currentStep - Current step
* @param {OnboardingFormData} props.formData - Onboarding data
* @param {React.Dispatch<React.SetStateAction<OnboardingFormData>>} props.setFormData - Onboarding data change handler
* @param {() => void} props.clearData - Clear data handler
* @returns TSX.Element
*/
const Step5Form = ({ currentStep, setStep, formData, setFormData, onPopup}: StepFormProps) => {
    const { t } = useTranslation(); // Translation
    const windowSize = useWindowSize(); // Window size
    const [chosenOption, setChosenOption] = useState<string>(formData.packagingType ? formData.packagingType : "") // Current chosen options
    const [popupOpen, setPopupOpen] = useState<boolean>(false) // Popup display state
    
    const handleLargeAction = () => {
        // redirect to email or smth
        alert("vytvorena poptavka")
    };
    // Selection logic
    const handleSelection = (premium: boolean, option: string) =>{
        if(premium){// Open popup
            setPopupOpen(true)
        }else{
            setChosenOption(option)
        }
    }
    // Submit logic
    const handleAction = () => {
        setFormData((prev: typeof formData)=>({...prev,packagingType: chosenOption}))
        setStep(currentStep+1)
    }

    // Handle part skip
    const handleSkip = ()=>{
        setChosenOption("")
        setStep(currentStep+1)
    }
    return(
        <>
        {/*Large action popup */}
        <OnboardingPopup
            titleKey="onboarding.steps.5.popup.title"
            contentKey="onboarding.steps.5.popup.content"
            display={popupOpen}
            onClose={() => setPopupOpen(false)}
            onSubmit={() => handleLargeAction()}
            onPopup={onPopup}
        />
        <div className={styles.OnboardingContent}>
            <div className={styles.Container}>
                <div className={styles.SecondaryTitle}>
                    <p>{t("onboarding.steps.5.title")}</p>
                </div>
                <div className={styles.ActionButtons}>
                    <SecondaryButton onClick={()=>handleSelection(true, "Premium")} text={t("onboarding.steps.5.buttons.porcelain")}  className={`${chosenOption =="Premium" ? `${styles.ChosenOption}` : undefined} ${styles.ChoiceButtonRound}`} showChevron={false} colorVariant="primary"/>
                    <SecondaryButton onClick={()=>handleSelection(false, "Paper")} text={t("onboarding.steps.5.buttons.paper")} className={`${chosenOption =="Paper" ? `${styles.ChosenOption}` : undefined} ${styles.ChoiceButtonRound}`} showChevron={false} colorVariant="primary"/>
                </div>
                <div  className={styles.ContinueButton}>
                    {windowSize > 900 && <SecondaryButton text={t("onboarding.steps.5.dismiss")} colorVariant="neutral" onClick={()=>handleSkip()} showChevron={false}/>}
                    <PrimaryButton onClick={()=>handleAction()} text={t("buttons.proceed")}/>
                </div>
            </div>
        </div>
        </>
    )
};

export default Step5Form;
